import {EmailBanner} from './email/emailBanner';
import {TSMap} from 'typescript-map';
import {JsonObject, JsonProperty} from 'json2typescript';
import {TextMessage} from './email/TextMessage';
import {TsMapBannersMapConverter} from '../customJsonConverters/TsMapBannersMapConverter';
import {TextMessageConverter} from '../customJsonConverters/TextMessageConverter';
import {EmailImage} from './email/emailImage';
import {EmailImageArrayConverter} from '../customJsonConverters/EmailImageArrayConverter';
import {MediaQuestion} from './media-question';
import {ProjectService} from '../project/project.service';

@JsonObject('Microsite')
export class Microsite {

  @JsonProperty('banners',TsMapBannersMapConverter)
  public micrositeBannerContent:TSMap<string, EmailBanner> = new TSMap();

  @JsonProperty('fontFamily',null,true)
  public fontFamily = 'N/A';

  @JsonProperty('fontSize',null,true)
  public fontSize = 0;

  @JsonProperty('fontColor',null,true)
  public fontColor = '#000000';

  @JsonProperty('fontWeight',null,true)
  public fontWeight = 'Lighter';

  @JsonProperty('background')
  public background = 'temp.jpg';

  // TODO must refactor this to a simple map; We will do it this way for now to comply with the back end model.
  // TODO This model assumes that we could have more than one text msg in a microsite.
  @JsonProperty('messageBoxes',TextMessageConverter)
  public texts:Array<TextMessage>=[];     // :TSMap<string,string> = new TSMap();

  @JsonProperty('blockImages',EmailImageArrayConverter,true)
  public blockImages:Array<EmailImage> = [];

  @JsonProperty('mediaQuestion',[MediaQuestion],true)
  public mediaQuestion: Array<MediaQuestion> = [];

  @JsonProperty('dynamicContentSharing',[String],true)
  public dynamicContentSharing:Array<string> = [];

  constructor() {
  }



  addDynamicContentToShare(val:string) {
    this.dynamicContentSharing.push(val);
  }

  removeDynamicContentToShare(val:string) {
    const idx = this.dynamicContentSharing.indexOf(val);
    this.dynamicContentSharing.splice(idx, 1);
  }

  // This is  the default method called to add the banner to the contentList
  onBannerSelected(file: File[]):void {
    for(const fic of file) {
      const emailBanner = new EmailBanner(); // new EmailBanner();
      emailBanner.position = 'Top';
      emailBanner.bannerName = fic.name;
      emailBanner.size = fic.size;
      this.micrositeBannerContent.set(fic.name, emailBanner);
    }
  }

  getBannerPosition(bannerName:string):string {
    return this.micrositeBannerContent.get(bannerName).position;
  }

  onBannerPositionChanged(bannerName:string, placement: string):void  {
    const emailBanner = this.micrositeBannerContent.get(bannerName);
    emailBanner.position = placement;
  }

  removeBannerFromMicrositeBannerContent(fileName:string):void {
    console.log(fileName);
    this.micrositeBannerContent.delete(fileName);
  }

  setFontFamily(choice:string) {
    this.fontFamily = choice;
  }

  setFontWeight(choice:string) {
    this.fontWeight = choice;
  }

  // microsite has only one text for now.
  getMessage(lang:string):string {
    if(this.texts.length === 0) {
      return;
    }
    return this.texts[0].message.texts.get(lang);
  }

  setMessage(lang:string,text:string):string {
    if(this.texts.length !== 0) {
      this.texts[0].message.texts.set(lang, text);
    } else {
      const tmp = new TextMessage();
      tmp.texts.set(lang,text);
      this.texts.push(tmp);
    }
    return text;
  }
}
